<div class="modal fade" id="filter-model">
  <div class="modal-dialog modal-width">
    <div class="modal-content">
      <div class="modal-filter-fix modal-body">
        <div class="modify_filter_title_mobile custom-panel-header">
          {{ rGuestBookMessages?.rooms?.roomFilterModalHeading }}
          <i
            data-dismiss="modal"
            style="position: absolute; right: 0; margin-right: 15px; top: 0; margin-top: 11px"
            class="fa fa-times"
            aria-hidden="true"></i>
        </div>
        <mat-card-content class="filter_content">
          <div *ngIf="rGuestBookRoutePermissions">
            <mat-form-field *ngIf="!isIE11 && !restrictDateSelection" class="col-12">
              <input
                type="text"
                style="cursor: pointer"
                name="date"
                [minDate]="minDate"
                [(ngModel)]="initialValue"
                #ctrl="ngModel"
                autocomplete="off"
                (Change)="validatedates(initialValue)"
                matInput
                placeholder="{{ rGuestBookMessages?.rooms?.roomArrDepDatePlaceholder }}"
                bsDaterangepicker
                placement="bottom"
                readonly
                (onShown)="onShowPicker($event)"
                [bsConfig]="bsConfig"
                #dpr1="bsDaterangepicker" />
            </mat-form-field>
            <mat-form-field *ngIf="!isIE11 && restrictDateSelection" class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <input
                type="text"
                style="cursor: pointer"
                name="date"
                [minDate]="minDate"
                [(ngModel)]="initialValue"
                #ctrl="ngModel"
                autocomplete="off"
                (Change)="validatedates(initialValue)"
                matInput
                placeholder="{{ rGuestBookMessages?.rooms?.roomArrDepDatePlaceholder }}"
                bsDaterangepicker
                placement="bottom"
                readonly
                (onShown)="onShowPicker($event)"
                [bsConfig]="bsConfig"
                [datesDisabled]="restrictedDates"
                #dpr1="bsDaterangepicker" />
            </mat-form-field>
            <mat-form-field *ngIf="isIE11" class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <input
                matInput
                #arrDate1="ngModel"
                [(ngModel)]="IEarrival"
                [min]="minDate"
                (ngModelChange)="validateArrDate1(IEarrival)"
                [matDatepicker]="arrPicker1"
                placeholder="{{ rGuestBookMessages?.rooms?.roomIEArrivalDatePlaceholder || 'Arrival Date' }}" />
              <mat-datepicker-toggle matSuffix [for]="arrPicker1"></mat-datepicker-toggle>
              <mat-datepicker [panelClass]="arrDatePickerCard" #arrPicker1></mat-datepicker>
            </mat-form-field>
            <mat-form-field *ngIf="isIE11" class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <input
                matInput
                #depDate1="ngModel"
                [(ngModel)]="IEdeparture"
                [min]="IEarrival"
                (ngModelChange)="validateDepDate1(IEdeparture)"
                [matDatepicker]="depPicker1"
                placeholder="{{ rGuestBookMessages?.rooms?.roomIEDepartureDatePlaceholder || 'Departure Date' }}" />
              <mat-datepicker-toggle matSuffix [for]="depPicker1"></mat-datepicker-toggle>
              <mat-datepicker [panelClass]="depDatePickerCard" #depPicker1></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col-xs-3 col-sm-3 col-md-3 col-lg-3" *ngIf="!AppInitializer?.multiGuestType">
              <mat-select placeholder="{{ rGuestBookMessages?.rooms?.roomNoOfGuestPlaceholder }}" [(value)]="selected">
                <mat-option value="1">1</mat-option>
                <mat-option value="2">2</mat-option>
                <mat-option value="3">3</mat-option>
                <mat-option value="4">4</mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="AppInitializer?.multiGuestType" class="grid-wrapper">
              <div class="filter-fields col-xs-6 col-sm-6 col-md-6 col-lg-6" *ngFor="let detail of AppInitializer?.guestTypeLimit">
                <mat-form-field>
                  <mat-select
                    placeholder="{{ detail.label }}"
                    [(value)]="detail.selectedValue"
                    matTooltip="{{ detail.toolTip }}"
                    (selectionChange)="getGuestDetails(detail, $event)">
                    <mat-option *ngFor="let val of fetchValues(detail)" value="{{ val }}">{{ val }} </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <mat-form-field
              *ngIf="rGuestBookRoutePermissions.functionalPermissions?.casinoNumber_casinoNumberRoomsPage"
              class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3 col-sm-12 col-md-12 col-lg-12">
              <input
                (keydown.enter)="$event.preventDefault()"
                [disabled]="casinoValidateHide"
                type="text"
                id="roomcasinonumber"
                placeholder="{{ rGuestBookMessages?.rooms?.roomCasinoNumberPlaceholder }}"
                matInput
                [(ngModel)]="casinoNumber"
                #casinoNo="ngModel"
                pattern="[a-zA-Z0-9 #\-]*"
                name="casinoNo"
                [disabled]="rooms && rooms?.isCasinoOffer && rooms?.isCasinoOffer != '' && i == 0" />
              <button
                (keydown.enter)="$event.preventDefault()"
                id="casinoNumberGo"
                mat-button
                *ngIf="casinoNumber && !casinoValidateHide"
                matSuffix
                mat-icon-button
                (click)="validateCasinoPlayer(casinoNumber)">
                <mat-icon>arrow_forward</mat-icon>
              </button>
              <button
                (keydown.enter)="$event.preventDefault()"
                id="casinoNumberclear"
                mat-button
                *ngIf="casinoNumber && !casinoValidateHide"
                matSuffix
                mat-icon-button
                (click)="casinoNumber = ''">
                <mat-icon>clear</mat-icon>
              </button>
            </mat-form-field>

            <mat-form-field
              *ngIf="rGuestBookRoutePermissions.functionalPermissions?.offerCode_offerCodeRoomsPage"
              class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3 col-sm-12 col-md-12 col-lg-12">
              <i
                *ngIf="
                  rGuestBookRoutePermissions.functionalPermissions?.offerCode_offerDetailsRoomsPage &&
                  (selectedOffer.quickLook == true || selectedOffer.arrivalDayFlag == true || selectedOffer.offerTextArray?.length)
                "
                class="fa fa-eye eye-on-offer"
                data-toggle="modal"
                href="#offers-modal"
                (click)="displayOfferDetails(offerCode)"
                aria-hidden="true"></i>
              <span style="position: relative">
                <input
                  name="offerCode"
                  [(ngModel)]="offerCode"
                  id="roomoffercodeselect"
                  matInput
                  disabled
                  #ctrl="ngModel"
                  placeholder="{{ rGuestBookMessages?.rooms?.roomOfferCodePlaceholder }}" />
                <div
                  data-dismiss="modal"
                  style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; cursor: pointer"
                  id="roomoffercodeselect"
                  (click)="passTheValue()"></div>
              </span>
            </mat-form-field>
          </div>
          <div
            *ngIf="
              casinoNumber &&
              casinoValidateHide &&
              casinoPlayerName &&
              rGuestBookRoutePermissions.functionalPermissions?.casinoNumber_casinoPlayerRankCard
            "
            class="casino-card">
            <img
              alt="img"
              class="casino-cardImg"
              [src]="assetsURL + casinoRankCard + '.png' | azureBlobToken"
              (error)="errorPlayerCardHandler($event)" />
            <h4 class="casino-playerName">{{ casinoPlayerName }}</h4>
          </div>
        </mat-card-content>
        <mat-card-actions class="filter_actions">
          <button data-dismiss="modal" mat-raised-button class="button_style" (click)="refineSearch()">
            {{ rGuestBookMessages?.rooms?.roomFilterSearchBtn }}
          </button>
        </mat-card-actions>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="offers-modal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-filter-fix modal-body">
        <mat-card class="offer_filter_modal">
          <div class="modify_offer_title">
            {{ offerCode }} {{ rGuestBookMessages?.rooms?.roomOfferPlaceholder }}
            <i
              data-dismiss="modal"
              style="position: absolute; right: 0; margin-right: 15px; top: 0; margin-top: 11px"
              class="fa fa-times"
              aria-hidden="true"></i>
          </div>
          <mat-card-content *ngIf="selectedOffer" class="offer_content">
            <div *ngIf="selectedOffer.quickLook == true || selectedOffer.arrivalDayFlag == true">
              <div class="panel panel-quickLook">
                <div class="panel-heading">
                  <h3 class="panel-title">{{ rGuestBookMessages?.rooms?.roomQuickLook }}</h3>
                </div>
                <div class="panel-body">
                  <div class="container-fluid">
                    <ul class="row">
                      <li
                        class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyEarliestArrival"
                        *ngIf="selectedOffer.earliestArrivalDate">
                        <i class="quick_look fa fa-calendar-plus-o" aria-hidden="true"></i>
                        <p>{{ rGuestBookMessages?.rooms?.roomEarliestArrDate }}</p>
                        <strong>
                          <p style="color: #607d8b; font-weight: 900">
                            {{ selectedOffer.earliestArrivalDate | custDate: AppInitializer?.PropertyData?.dateFunctionConfig }}
                          </p>
                        </strong>
                      </li>
                      <li
                        class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyLatestArrival"
                        *ngIf="selectedOffer.latestArrivalDate">
                        <i class="quick_look fa fa-calendar-minus-o" aria-hidden="true"></i>
                        <p>{{ rGuestBookMessages?.rooms?.roomLatestArrDate }}</p>
                        <strong>
                          <p style="color: #607d8b; font-weight: 900">
                            {{ selectedOffer.latestArrivalDate | custDate: AppInitializer?.PropertyData?.dateFunctionConfig }}
                          </p>
                        </strong>
                      </li>
                      <li
                        class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyBookingStarts"
                        *ngIf="selectedOffer.earliestSalesDate">
                        <i class="quick_look fa fa-calendar-check-o" aria-hidden="true"></i>
                        <p>{{ rGuestBookMessages?.rooms?.roomBookingStarts }}</p>
                        <strong>
                          <p style="color: #607d8b; font-weight: 900">
                            {{ selectedOffer.earliestSalesDate | custDate: AppInitializer?.PropertyData?.dateFunctionConfig }}
                          </p>
                        </strong>
                      </li>
                      <li
                        class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyBookingEnds"
                        *ngIf="selectedOffer.latestSalesDate">
                        <i class="quick_look fa fa-calendar-check-o" aria-hidden="true"></i>
                        <p>{{ rGuestBookMessages?.rooms?.roomBookingEnds }}</p>
                        <strong>
                          <p style="color: #607d8b; font-weight: 900">
                            {{ selectedOffer.latestSalesDate | custDate: AppInitializer?.PropertyData?.dateFunctionConfig }}
                          </p>
                        </strong>
                      </li>
                      <li
                        class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMinNights"
                        *ngIf="selectedOffer.minimumNights">
                        <i class="minimum-nights quick_look fa fa-moon-o" aria-hidden="true"></i>
                        <p>{{ rGuestBookMessages?.rooms?.roomMinNights }}</p>
                        <strong>
                          <p style="color: #607d8b; font-weight: 900">
                            {{ selectedOffer.minimumNights }}
                            {{ rGuestBookMessages?.rooms?.roomNightsPlaceholder }}
                          </p>
                        </strong>
                      </li>
                      <li
                        class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMinPurchase"
                        *ngIf="selectedOffer.minimumAdvancePurchase">
                        <i class="quick_look min-purchase fa fa-arrow-circle-o-right" aria-hidden="true"></i>
                        <p>{{ rGuestBookMessages?.rooms?.roomMinAdvancePurchase }}</p>
                        <strong>
                          <p style="color: #607d8b; font-weight: 900">
                            {{ selectedOffer.minimumAdvancePurchase }}
                            {{ rGuestBookMessages?.rooms?.roomNightsPlaceholder }}
                          </p>
                        </strong>
                      </li>
                      <li
                        class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMaxPurchase"
                        *ngIf="selectedOffer.maximumAdvancePurchase">
                        <i class="quick_look max-purchase fa fa-arrow-circle-o-left" aria-hidden="true"></i>
                        <p>{{ rGuestBookMessages?.rooms?.roomMaxAdvancePurchase }}</p>
                        <strong>
                          <p style="color: #607d8b; font-weight: 900">
                            {{ selectedOffer.maximumAdvancePurchase }}
                            {{ rGuestBookMessages?.rooms?.roomDaysPlaceholder }}
                          </p>
                        </strong>
                      </li>
                      <li
                        class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMaxNights"
                        *ngIf="selectedOffer.maximumNights">
                        <i class="maximum-nights quick_look fa fa-moon-o" aria-hidden="true"></i>
                        <p>{{ rGuestBookMessages?.rooms?.roomMaxNights }}</p>
                        <strong>
                          <p style="color: #607d8b; font-weight: 900">
                            {{ selectedOffer.maximumNights }}
                            {{ rGuestBookMessages?.rooms?.roomNightsPlaceholder }}
                          </p>
                        </strong>
                      </li>
                      <li
                        class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyNoArrival"
                        *ngIf="selectedOffer.arrivalDayFlag == true">
                        <i class="quick_look fa fa-ban" aria-hidden="true"></i>
                        <p>{{ rGuestBookMessages?.rooms?.roomNoArrival }}</p>
                        <div>
                          <div class="overflow_scroll">
                            <div class="day-display">
                              <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Monday === false">
                                {{ "Mon" | custCalDayName: AppInitializer?.PropertyData?.dateFunctionConfig }}
                              </h5>
                              <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Tuesday === false">
                                {{ "Tue" | custCalDayName: AppInitializer?.PropertyData?.dateFunctionConfig }}
                              </h5>
                              <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Wednesday === false">
                                {{ "Wed" | custCalDayName: AppInitializer?.PropertyData?.dateFunctionConfig }}
                              </h5>
                              <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Thursday === false">
                                {{ "Thu" | custCalDayName: AppInitializer?.PropertyData?.dateFunctionConfig }}
                              </h5>
                              <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Friday === false">
                                {{ "Fri" | custCalDayName: AppInitializer?.PropertyData?.dateFunctionConfig }}
                              </h5>
                              <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Saturday === false">
                                {{ "Sat" | custCalDayName: AppInitializer?.PropertyData?.dateFunctionConfig }}
                              </h5>
                              <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Sunday === false">
                                {{ "Sun" | custCalDayName: AppInitializer?.PropertyData?.dateFunctionConfig }}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="selectedOffer.offerTextArray?.length" class="panel panel-offer-detail">
              <div class="panel-heading">
                <h3 class="panel-title">{{ selectedOffer.offerDescription }}</h3>
              </div>
              <div class="panel-body">
                <div *ngFor="let description of selectedOffer.offerTextArray">
                  <p *ngIf="description?.length">
                    <i class="fa fa-dot-circle-o" aria-hidden="true"></i> &nbsp;<span [innerHtml]="description | safeHtml"></span>
                  </p>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<mat-drawer-container
  [attr.fullscreen]="fullscreenView ? 'true' : null"
  CdkScrollable
  autosize
  class="example-container roomContainerBody"
  (backdropClick)="closeSidebar()">
  <mat-drawer mode="over" [opened]="triggerSidebar" #sidenav class="example-sidenav" data-modal-index="2">
    <div style="position: relative">
      <app-offers
        [pageFromRoom]="true"
        [casinoNumberpanel]="casinoNumber"
        [guestCount]="selected"
        [casinoNumber]="casinoNumber"
        (loginFromOffers)="loginFromOffers($event)"
        [origin]="'rooms'"
        [defaultHeight]="passHeight + 21"
        [offerValue]="offerCode"
        [selectedTab]="offersTab"
        (callFun)="afterInit()"
        (someEvent)="toggleSidebar($event)"
        [viewFilter]="false"
        #offers
        [ArrDepDate]="initialValue"
        [viewSelectButton]="true"
        [viewBookButton]="false"
        [viewDetailsButton]="true">
      </app-offers>
      <button (click)="closeSidebar()" class="close-sidenav" mat-fab style="z-index: 999">
        <i class="fa fa-times fa-close-button fa-closees-button" aria-hidden="true"></i>
      </button>
    </div>
  </mat-drawer>

  <div class="row-un-wrapper">
    <div *ngIf="rGuestBookRoutePermissions" class="col-lg-3 unset-padding custom-col-3">
      <mat-card class="overlay room_filter">
        <div class="modify_filter_title custom-modify-filter-title">
          {{ rGuestBookMessages?.rooms?.roomFilterLabel }}
        </div>
        <mat-card-content class="filter_content">
          <div class="row row-remover">
            <mat-form-field *ngIf="!isIE11 && !restrictDateSelection" class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3 col-wrapper">
              <input
                type="text"
                style="cursor: pointer"
                id="roombsvaluedatepicker"
                [(bsValue)]="initialValue"
                readonly
                (bsValueChange)="validatedates(initialValue)"
                (onShown)="datePickerOpened()"
                (onHidden)="datePickerHidden()"
                autocomplete="off"
                name="date"
                matInput
                placeholder="{{ rGuestBookMessages?.rooms?.roomArrDepDatePlaceholder }}"
                [minDate]="minDate"
                bsDaterangepicker
                placement="bottom"
                [bsConfig]="bsConfig"
                #dpr="bsDaterangepicker" />
            </mat-form-field>
            <mat-form-field
              *ngIf="!isIE11 && restrictDateSelection"
              class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3 custom-min-date">
              <input
                type="text"
                style="cursor: pointer"
                id="roombsvaluedatepicker"
                [(bsValue)]="initialValue"
                readonly
                (bsValueChange)="validatedates(initialValue)"
                (onShown)="datePickerOpened()"
                (onHidden)="datePickerHidden()"
                autocomplete="off"
                name="date"
                matInput
                placeholder="{{ rGuestBookMessages?.rooms?.roomArrDepDatePlaceholder }}"
                [minDate]="minDate"
                bsDaterangepicker
                placement="bottom"
                [bsConfig]="bsConfig"
                [datesDisabled]="restrictedDates"
                #dpr="bsDaterangepicker" />
            </mat-form-field>
            <mat-form-field *ngIf="isIE11" class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <input
                matInput
                #arrDate1="ngModel"
                [(ngModel)]="IEarrival"
                [min]="minDate"
                (ngModelChange)="validateArrDate(IEarrival)"
                [matDatepicker]="arrPicker"
                placeholder="{{ rGuestBookMessages?.rooms?.roomIEArrivalDatePlaceholder || 'Arrival Date' }}" />
              <mat-datepicker-toggle matSuffix [for]="arrPicker"></mat-datepicker-toggle>
              <mat-datepicker [panelClass]="arrDatePickerCard" #arrPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field *ngIf="isIE11" class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3">
              <input
                matInput
                #depDate1="ngModel"
                [(ngModel)]="IEdeparture"
                [min]="IEarrival"
                (ngModelChange)="validateDepDate(IEdeparture)"
                [matDatepicker]="depPicker"
                placeholder="{{ rGuestBookMessages?.rooms?.roomIEDepartureDatePlaceholder || 'Departure Date' }}" />
              <mat-datepicker-toggle matSuffix [for]="depPicker"></mat-datepicker-toggle>
              <mat-datepicker [panelClass]="depDatePickerCard" #depPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="filter-fields noOfGuests col-xs-3 col-sm-3 col-md-3 col-lg-3" *ngIf="!AppInitializer?.multiGuestType">
              <mat-select
                id="roomnoofguestselect"
                placeholder="{{ rGuestBookMessages?.rooms?.roomNoOfGuestPlaceholder }}"
                (selectionChange)="guestDetailsChanged()"
                [(value)]="selected">
                <mat-option value="1">1</mat-option>
                <mat-option value="2">2</mat-option>
                <mat-option value="3">3</mat-option>
                <mat-option value="4">4</mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="AppInitializer?.multiGuestType" class="grid-wrapper">
              <div class="filter-fields col-xs-6 col-sm-6 col-md-6 col-lg-6" *ngFor="let detail of AppInitializer?.guestTypeLimit">
                <mat-form-field>
                  <mat-select
                    placeholder="{{ detail.label }}"
                    [(value)]="detail.selectedValue"
                    matTooltip="{{ detail.toolTip }}"
                    (selectionChange)="getGuestDetails(detail, $event)">
                    <mat-option *ngFor="let val of fetchValues(detail)" value="{{ val }}">{{ val }} </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <mat-form-field
              *ngIf="rGuestBookRoutePermissions.functionalPermissions?.casinoNumber_casinoNumberRoomsPage"
              class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3 col-wrapper">
              <input
                (keydown.enter)="$event.preventDefault()"
                [disabled]="casinoValidateHide"
                type="text"
                id="calendarcasinonumber"
                placeholder="{{ rGuestBookMessages?.rooms?.roomCasinoNumberPlaceholder }}"
                matInput
                [(ngModel)]="casinoNumber"
                #casinoNo="ngModel"
                pattern="[a-zA-Z0-9 #\-]*"
                name="casinoNo"
                [disabled]="rooms && rooms?.isCasinoOffer && rooms?.isCasinoOffer != '' && i == 0" />
              <button
                (keydown.enter)="$event.preventDefault()"
                id="casinoNumberGo"
                mat-button
                *ngIf="casinoNumber && !casinoValidateHide"
                matSuffix
                mat-icon-button
                (click)="validateCasinoPlayer(casinoNumber)">
                <mat-icon>arrow_forward</mat-icon>
              </button>
              <button
                (keydown.enter)="$event.preventDefault()"
                id="casinoNumberclear"
                mat-button
                *ngIf="casinoNumber && !casinoValidateHide"
                matSuffix
                mat-icon-button
                (click)="casinoNumber = ''">
                <mat-icon>clear</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field
              *ngIf="rGuestBookRoutePermissions.functionalPermissions?.offerCode_offerCodeRoomsPage"
              class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3 col-wrapper">
              <i
                *ngIf="
                  rGuestBookRoutePermissions.functionalPermissions?.offerCode_offerDetailsRoomsPage &&
                  (selectedOffer.quickLook == true || selectedOffer.arrivalDayFlag == true || selectedOffer.offerTextArray?.length)
                "
                class="fa fa-eye eye-on-offer"
                data-toggle="modal"
                href="#offers-modal"
                (click)="displayOfferDetails(offerCode)"
                aria-hidden="true"></i>
              <span style="position: relative">
                <input
                  name="offerCode"
                  [(ngModel)]="offerCode"
                  id="roomoffercodeselect"
                  matInput
                  disabled
                  #ctrl="ngModel"
                  placeholder="{{ rGuestBookMessages?.rooms?.roomOfferCodePlaceholder }}" />
                <div
                  data-dismiss="modal"
                  style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; cursor: pointer"
                  id="roomoffercodeselect"
                  (click)="passTheValue()"></div>
              </span>
            </mat-form-field>
          </div>
          <div
            *ngIf="
              casinoNumber &&
              casinoValidateHide &&
              casinoPlayerName &&
              rGuestBookRoutePermissions.functionalPermissions?.casinoNumber_casinoPlayerRankCard
            "
            class="casino-card">
            <img
              alt="img"
              class="casino-cardImg"
              [src]="assetsURL + casinoRankCard + '.png' | azureBlobToken"
              (error)="errorPlayerCardHandler($event)" />
            <h4 class="casino-playerName">{{ casinoPlayerName }}</h4>
          </div>
        </mat-card-content>
        <mat-card-actions class="filter_actions" *ngIf="!rGuestBookRoutePermissions.functionalPermissions?.enableAutoSearch">
          <button id="refineSearch" mat-raised-button class="button_style" (click)="refineSearch()">
            {{ rGuestBookMessages?.rooms?.roomFilterSearchBtn }}
          </button>
        </mat-card-actions>
      </mat-card>
      <div class="clearfix"></div>
    </div>

    <div
      appWindowHeight
      (windowWidth)="setWidth($event)"
      (defaultHeights)="setHeight($event)"
      id="scrollingItem"
      class="container-room-top col-xs-12 col-sm-12 col-lg-9 col-12 custom-col-9">
      <div class="room_data">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div *ngIf="!hasInvalidDates" class="roomDataFilterWrapper room-filter-card">
            <h4 class="roomDataFilter">
              <strong>{{ rGuestBookMessages?.rooms?.roomDateLabel }} </strong>
              {{ this.arrDate | custDate: AppInitializer?.PropertyData?.dateFunctionConfig }} -
              {{ this.depDate | custDate: AppInitializer?.PropertyData?.dateFunctionConfig }}
            </h4>
            <p class="info-text roomDataFilter1 room-filter-card-content">
              <i aria-hidden="true">{{ rGuestBookMessages?.rooms?.roomDatePara }}</i>
            </p>
            <div style="margin-top: -12px">
              <button
                *ngIf="rGuestBookRoutePermissions.functionalPermissions?.togglefilterButtonToTop"
                mat-button
                class="button-color filter-top-button mb-1 mr-1"
                data-dismiss="modal"
                data-toggle="modal"
                href="#filter-model">
                {{ rGuestBookMessages?.rooms?.roomTabFilterText || "Filter" }}
              </button>
              <button
                *ngIf="rGuestBookRoutePermissions.routePermissions.calendar"
                class="roomDataFilterButtonCalendar mb-1 mr-1"
                (click)="openCalendarModal()"
                mat-raised-button
                color="primary">
                {{ rGuestBookMessages?.rooms?.roomTabFlexibleDates }}
              </button>
              <button
                *ngIf="AppInitializer?.PropertyData?.permissions?.functionalPermissions?.advancedFilter && filters && filters?.length > 0"
                class="roomDataFilterButtonCalendar mb-1 mr-1"
                (click)="openBottomSheetRoomFilter()"
                mat-raised-button
                color="primary">
                {{ rGuestBookMessages?.rooms?.advancedFilterBtn }}
              </button>
              <div style="margin-top: 10px" *ngIf="showFilterPanel">
                <details class="advancedFilterSectionTitle">
                  <summary>{{ rGuestBookMessages?.rooms?.advancedFilterSectionTitle }}</summary>
                  <div id="filterSection" style="padding: 20px 0px 10px">
                    <mat-chip-list aria-label="selection" style="display: block">
                      <ng-container *ngFor="let filterValue of objectValues(filtervalueobj); let i = index">
                        <div *ngIf="filterValue && filterValue?.length > 0">
                          <mat-chip
                            (click)="openBottomSheetRoomFilter()"
                            class="filter-chip custom-mat-standard-chip"
                            removable
                            (removed)="remove(objectKeys(filtervalueobj)[i])">
                            <div>
                              <span
                                style="font-size: 1.1rem; margin-top: -20px; white-space: nowrap; font-weight: bold"
                                class="filter-chip-label custom-filter-chip-label"
                                >{{ getLabel(objectKeys(filtervalueobj)[i]) | titlecase }}</span
                              >
                              <div style="word-break: break-word" class="custom-filter-chip-content">
                                {{ getFilterValue(objectKeys(filtervalueobj)[i], filterValue) }}
                              </div>
                            </div>
                            <mat-icon class="filter-chip-close-icon" matChipRemove>cancel </mat-icon>
                          </mat-chip>
                        </div>
                      </ng-container>
                    </mat-chip-list>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="errorPopup" class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class="alert alert-warning">
            <strong>{{ errorPopup }}</strong>
            <div *ngIf="hasInvalidDates" style="margin-top: 10px">
              <button
                *ngIf="rGuestBookRoutePermissions.functionalPermissions?.togglefilterButtonToTop"
                mat-button
                class="button-color filter-top-button filter-top-button-onError"
                data-dismiss="modal"
                data-toggle="modal"
                href="#filter-model">
                {{ rGuestBookMessages?.rooms?.roomTabFilterText || "Filter" }}
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="roomPreload">
          <div class="text-center">
            <i class="animated-preload1 fa fa-circle faa-burst animated" aria-hidden="true"></i> &nbsp;
            <i class="animated-preload2 fa fa-circle faa-burst animated" aria-hidden="true"></i>&nbsp;
            <i class="animated-preload3 fa fa-circle faa-burst animated" aria-hidden="true"></i>&nbsp;
          </div>
        </div>
        <div class="rooms-Container">
          <div class="grid-wrapper">
            <div
              class="animated zoomIn col-xs-12 col-sm-12 col-md-6 col-lg-6"
              id="emptyFilter"
              *ngIf="filteredItems.length == 0 && emptyFilterVisibility && roomList.length > 0">
              {{ rGuestBookMessages?.rooms?.filterEmptyRoomText }}
            </div>
            <ng-container *ngIf="!errorPopup">
              <div
                style="margin-bottom: 20px"
                (deferLoad)="room.showImage = true"
                *ngFor="
                  let room of filteredItems | roomorder: rGuestBookRoutePermissions.functionalPermissions?.shownBestRateRibbon;
                  let i = index
                "
                id="room-panel{{ i }}"
                class="animated zoomIn col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div
                  *ngIf="room.hasComp && !room.blockRoom && rGuestBookRoutePermissions.functionalPermissions?.shownBestRateRibbon"
                  class="ribbonRoom">
                  <span>{{ rGuestBookMessages?.rooms?.bestRateRibbonText }}</span>
                </div>
                <div class="block-container" *ngIf="room.blockRoom == true">
                  <h2 class="text-soldout">{{ rGuestBookMessages?.rooms?.roomSoldOut }}</h2>
                </div>
                <div *ngIf="room.blockRoom == false" class="book-button-link">
                  <div [matTooltip]="disableCart ? cartMsg : ''">
                    <button
                      id="bookBtnRoomCard"
                      (click)="bookFromTop(room)"
                      *ngIf="!room.previousPlayerStay"
                      [disabled]="disableCart"
                      class="btn-book btn-book-disable"
                      mat-raised-button
                      color="primary">
                      {{ rGuestBookMessages?.rooms?.roomIndividualCardBookButton }}
                    </button>
                  </div>
                  <div [matTooltip]="disableCart ? cartMsg : ''">
                    <button
                      id="bookAgainBtnRoomCard"
                      (click)="bookFromTop(room)"
                      *ngIf="room.previousPlayerStay"
                      [disabled]="disableCart"
                      class="btn-book btn-bookAgain"
                      mat-raised-button
                      color="primary">
                      {{ rGuestBookMessages?.rooms?.roomInidvidualCardBookAgainButton }}
                    </button>
                  </div>
                </div>
                <div *ngIf="room.blockRoom == true" class="book-button-link">
                  <button disabled *ngIf="!room.previousPlayerStay" class="btn-book btn-book-disable" mat-raised-button color="primary">
                    {{ rGuestBookMessages?.rooms?.roomIndividualCardBookButton }}
                  </button>
                  <button disabled *ngIf="room.previousPlayerStay" class="btn-book btn-book-disable" mat-raised-button color="primary">
                    {{ rGuestBookMessages?.rooms?.roomInidvidualCardBookAgainButton }}
                  </button>
                </div>
                <div *ngIf="filteredItems" (click)="showDetails(room, i)" style="background-color: white; cursor: pointer" class="RoomCard">
                  <div id="mat-card{{ i }}">
                    <div id="hover-content">
                      {{ rGuestBookMessages?.rooms?.roomViewDetails }}
                    </div>
                    <div *ngIf="room.roomsImages" class="image-scroll">
                      <div id="carousel-id{{ i }}" class="roomCardImage slide" data-ride="carousel">
                        <ng-container *ngIf="room.showImage">
                          <img
                            (error)="errorRoomImageHandler(room, $event, room.roomCode, room.roomsImages[0], true, i)"
                            alt="{{ room.roomsImages[0] }}"
                            [src]="
                              assetsURL + 'rooms/' + (room.roomCode | azurefolder) + '/' + (room.roomsImages[0] | azurefolder)
                                | azureBlobToken
                            " />
                        </ng-container>
                      </div>
                    </div>
                    <div
                      class="roomleftmsg"
                      *ngIf="
                        room.rateSnapshot[0].showRemainingRooms &&
                        room?.rateSnapshot[0]?.nightAvailable &&
                        !rGuestBookRoutePermissions.functionalPermissions?.hideInventoryCount
                      ">
                      <p class="hurry-text">
                        {{ rGuestBookMessages?.rooms?.roomHurryMessage1 }}
                        <span *ngIf="showRemainingRoomsCount && room.rateSnapshot[0].remainingRooms > 0">
                          {{ room.rateSnapshot[0].remainingRooms }}
                        </span>
                        <span *ngIf="showRemainingRoomsCount && room.rateSnapshot[0].remainingRooms <= 0">
                          {{ rGuestBookMessages?.rooms?.roomHurryMessage2 }}
                        </span>
                        <span *ngIf="!showRemainingRoomsCount">{{ rGuestBookMessages?.rooms?.roomHurryMessage2 }}</span
                        >{{ rGuestBookMessages?.rooms?.roomHurryMessage3 }}
                      </p>
                    </div>
                  </div>
                  <div class="title-card">
                    <div id="roomNameCard" class="pull-left rate-style rpageroomname">
                      {{ room.roomName | pcapitalize: disableCapitalizePipe }}
                    </div>
                    <div *ngIf="!room.isPackage">
                      <div *ngIf="room.blockRoom == false" class="rate-wrap mobile-head-rate rate-style">
                        <div *ngIf="room.days == room.compDays">
                          <p>{{ rGuestBookMessages?.rooms?.roomComplementaryMessage }}</p>
                          <span class="notice">{{ rGuestBookMessages?.rooms?.roomRecurringChargeTaxMessage }}</span>
                        </div>

                        <div [hidden]="room.days == room.compDays">
                          <span class="rate-style">{{ rGuestBookMessages?.rooms?.roomRatesMessage1 }}</span
                          >{{
                            (room.minRate || 0) * newRate
                              | custCurrency
                                : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                                : this.countryCode || AppInitializer?.PropertyData?.countryCode
                          }}
                          <span class="rate-style post-style">{{ rGuestBookMessages?.rooms?.roomRatesMessage2 }}</span>

                          <p class="rate-style" style="margin-top: -7px" *ngIf="room.hasComp">
                            {{ rGuestBookMessages?.rooms?.roomRatesMessage3 }}
                            <span>{{ room.compDays }}</span
                            >{{ rGuestBookMessages?.rooms?.roomRatesMessage4 }}
                          </p>
                        </div>
                      </div>
                      <div
                        *ngIf="room.blockRoom == true && room.minRate != 0.0 && !hideRateDepositAndCancelPoliciesIfSoldOut"
                        class="rate-wrap mobile-head-rate">
                        <p class="soldOut">
                          {{ rGuestBookMessages?.rooms?.roomRatesMessage5 }}
                          <span class="rate-style" [hidden]="room.days == room.compDays"
                            >{{ rGuestBookMessages?.rooms?.roomRatesMessage6 }}
                            {{
                              (room.minRate || 0) * newRate
                                | custCurrency
                                  : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                                  : this.countryCode || AppInitializer?.PropertyData?.countryCode
                            }}
                            {{ rGuestBookMessages?.rooms?.roomRatesMessage7 }}</span
                          >
                          <span [hidden]="room.days != room.compDays">{{ rGuestBookMessages?.rooms?.roomRatesMessage8 }}</span>
                        </p>
                      </div>
                      <div
                        *ngIf="room.blockRoom == true && room.minRate != 0.0 && hideRateDepositAndCancelPoliciesIfSoldOut"
                        class="rate-wrap mobile-head-rate">
                        <p class="soldOut">
                          {{ rGuestBookMessages?.rooms?.roomRatesMessage5 }}
                        </p>
                      </div>
                      <div *ngIf="room.blockRoom == true && room.minRate == 0.0" class="rate-wrap mobile-head-rate">
                        <p class="soldOut">{{ rGuestBookMessages?.rooms?.roomRatesMessage9 }}</p>
                      </div>
                    </div>
                    <div *ngIf="room.isPackage">
                      <div class="rate-wrap mobile-head-rate">
                        <span class="rate-style">{{ rGuestBookMessages?.rooms?.roomRatesPackageMessage }}</span>
                        {{
                          (room.quoteTotal || 0) * newRate
                            | custCurrency
                              : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                              : this.countryCode || AppInitializer?.PropertyData?.countryCode
                        }}
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <div *ngIf="room.previousPlayerStay" class="pull-left">
                      <span class="playerstay">{{ rGuestBookMessages?.rooms?.roomLastTimeMessage }}</span>
                    </div>
                  </div>
                </div>
                <div id="showArrow{{ i }}" class="arrow-down"></div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="detailstab" class="detailstab" [hidden]="!details_tab" *ngIf="filteredItems.length > 0">
    <div *ngIf="details_tab && filteredItems.length > 0">
      <h3 class="room_name">{{ selectedTab.roomName | pcapitalize: disableCapitalizePipe }}</h3>

      <button id="closeRoomDetails" class="close-details" (click)="closeTab(selectedTab)" mat-fab>
        <i class="fa fa-times fa-close-button" aria-hidden="true"></i>
      </button>
      <button class="close-details-mini" (click)="closeTab(selectedTab)" mat-fab id="closeDetailsMini">
        <i class="fa fa-times fa-close-button" aria-hidden="true"></i>
      </button>
      <div class="grid-wrapper">
        <div style="padding: 10px" class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div
            *ngIf="selectedTab.roomsImages"
            id="carousel-id"
            class="carousel_slider carousel carouselCardImage slide carousel_room"
            data-ride="carousel">
            <ol class="carousel-indicators" *ngIf="selectedTab.roomsImages.length > 1">
              <ng-container *ngFor="let img of selectedTab.roomsImages; let ii = index">
                <li [attr.data-target]="'#carousel-id'" [attr.data-slide-to]="ii" [class.active]="ii == 0" *ngIf="img != ''"></li>
              </ng-container>
            </ol>
            <div id="shopping-slider" class="carousel-inner carouselCardImageContainer">
              <ng-container *ngFor="let img of selectedTab.roomsImages; let ii = index">
                <div class="img-slide item carousel-item" [class.active]="ii == 0">
                  <img
                    class="carousel_slider"
                    [src]="assetsURL + 'rooms/' + (room.roomCode | azurefolder) + '/' + (img | azurefolder) | azureBlobToken"
                    [attr.alt]="selectedTab.roomName"
                    (error)="errorRoomImageHandler(selectedTab, $event, selectedTab.roomCode, img, false, ii)" />
                </div>
              </ng-container>
              <div class="img-slide item active" *ngIf="selectedTab.roomsImages.length == 0">
                <img [src]="defaultRoomImageURL | azureBlobToken" [attr.alt]="selectedTab.roomName" />
              </div>
            </div>
            <ng-container *ngIf="selectedTab.roomsImages.length > 1">
              <a class="carousel-control-prev" [attr.href]="'#carousel-id'" data-slide="prev">
                <i aria-hidden="true" class="carousel-control-prev-icon"></i>
              </a>
              <a class="carousel-control-next" [attr.href]="'#carousel-id'" data-slide="next">
                <i aria-hidden="true" class="carousel-control-next-icon"></i>
              </a>
            </ng-container>
          </div>
          <div *ngIf="selectedTab" class="row">
            <div class="col mt-3">
              <button disableRipple="true" *ngIf="!selectedTab.isPackage" mat-raised-button class="rate-details-wrap nohover">
                <div *ngIf="selectedTab.days == selectedTab.compDays && selectedTab.blockRoom == false">
                  <p>{{ rGuestBookMessages?.rooms?.roomComplementaryMessage }}</p>
                  <span class="notice-tab">{{ rGuestBookMessages?.rooms?.roomRecurringChargeTaxMessage }}</span>
                </div>
                <div *ngIf="selectedTab.days == selectedTab.compDays && selectedTab.blockRoom == true">
                  <p>{{ rGuestBookMessages?.rooms?.roomRatesMessage10 }}</p>
                </div>
                <div class="rate-style" *ngIf="selectedTab.days != selectedTab.compDays && selectedTab.blockRoom == false">
                  <span class="rate-style">{{ rGuestBookMessages?.rooms?.roomRatesMessage1 }}</span>
                  {{
                    (selectedTab.minRate || 0) * newRate
                      | custCurrency
                        : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                        : this.countryCode || AppInitializer?.PropertyData?.countryCode
                  }}
                  <span class="rate-style post-style">{{ rGuestBookMessages?.rooms?.roomRatesMessage2 }}</span>
                  <p class="rate-style" style="margin-top: -7px" *ngIf="selectedTab.hasComp">
                    {{ rGuestBookMessages?.rooms?.roomRatesMessage3 }}

                    <span>{{ selectedTab.compDays }}</span
                    >{{ rGuestBookMessages?.rooms?.roomRatesMessage11 }}
                  </p>
                </div>
                <div *ngIf="selectedTab.days != selectedTab.compDays && selectedTab.blockRoom == true">
                  <span class="rate-style">{{ rGuestBookMessages?.rooms?.roomRatesMessage10 }}</span>
                  <div style="margin-top: -10px; text-align: left">
                    <span class="rate-style rateStyle"
                      >{{
                        (selectedTab.minRate || 0) * newRate
                          | custCurrency
                            : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                            : this.countryCode || AppInitializer?.PropertyData?.countryCode
                      }}
                      {{ rGuestBookMessages?.rooms?.roomRatesMessage7 }}</span
                    >
                  </div>
                </div>
                <div></div>
              </button>
              <button
                style="margin-top: 0px !important"
                *ngIf="selectedTab.isPackage"
                class="policy-button btn-book-disable"
                mat-raised-button
                (click)="openCanellationDepositPolicy(selectedTab)">
                <i class="fa fa-file-text-o" aria-hidden="true" style="margin-right: 6px"></i
                >{{ rGuestBookMessages?.rooms?.roomDepCanPolicy }}
              </button>
            </div>
            <div *ngIf="selectedTab.blockRoom == false" class="col button-alignment custom-button-alignment">
              <div class="mt-3" [matTooltip]="disableCart ? cartMsg : ''" style="display: inline-block">
                <button
                  *ngIf="rGuestBookRoutePermissions.functionalPermissions?.addToCart"
                  id="cartBtnDetailsTab"
                  [disabled]="disableCart"
                  (click)="AddToCart(selectedTab, ii)"
                  class="cart-button btn-book-disable"
                  mat-raised-button>
                  <i style="margin-right: 5px; margin-top: -6px" class="fa fa-shopping-cart" aria-hidden="true"></i
                  >{{ rGuestBookMessages?.rooms?.roomIndividualCardCartButton }}
                </button>
              </div>
              <div class="mt-3" [matTooltip]="disableCart ? cartMsg : ''" style="display: inline-block">
                <button
                  id="bookBtnDetailsTab"
                  (click)="booktheRoom(selectedTab)"
                  *ngIf="!room.previousPlayerStay"
                  [disabled]="disableCart"
                  class="book-button btn-book-disable ml-2"
                  mat-raised-button>
                  {{ rGuestBookMessages?.rooms?.roomIndividualCardBookButton }}
                </button>
              </div>
              <div class="mt-3" [matTooltip]="disableCart ? cartMsg : ''" style="display: inline-block">
                <button
                  id="bookAgainBtnDetailsTab"
                  (click)="booktheRoom(selectedTab)"
                  *ngIf="room.previousPlayerStay"
                  [disabled]="disableCart"
                  class="book-button btn-bookAgain btn-book-disable ml-2"
                  mat-raised-button>
                  {{ rGuestBookMessages?.rooms?.roomInidvidualCardBookAgainButton }}
                </button>
              </div>
            </div>
            <!-- <div *ngIf="selectedTab.blockRoom == true" style="text-align:right;"
                            class="col-xs-12 col-sm-6 col-md-6 col-lg-7 buttonAlignment">
                            <button *ngIf="rGuestBookRoutePermissions.functionalPermissions?.addToCart" disabled
                                class="cart-button btn-book-disable" mat-raised-button>
                                <i style="    margin-right: 5px;
        margin-top: -6px;
    " class="fa fa-shopping-cart" aria-hidden="true"></i>{{rGuestBookMessages?.rooms?.roomIndividualCardCartButton}}</button>
                            <button id="bookBtnDetailsTab" (click)="booktheRoom(selectedTab)"
                                *ngIf="!room.previousPlayerStay" class="book-button"
                                mat-raised-button>{{rGuestBookMessages?.rooms?.roomIndividualCardBookButton}}</button>
                            <button id="bookAgainBtnDetailsTab" (click)="booktheRoom(selectedTab)"
                                *ngIf="room.previousPlayerStay" class="book-button btn-bookAgain"
                                mat-raised-button>{{rGuestBookMessages?.rooms?.roomInidvidualCardBookAgainButton}}</button>
                        </div> -->
            <div *ngIf="selectedTab.blockRoom == true" class="col button-alignment custom-button-alignment">
              <button
                *ngIf="rGuestBookRoutePermissions.functionalPermissions?.addToCart"
                disabled
                class="cart-button btn-book-disable mt-3"
                mat-raised-button>
                <i style="margin-right: 10px" class="fa fa-shopping-cart" aria-hidden="true"></i
                >{{ rGuestBookMessages?.rooms?.roomIndividualCardCartButton }}
              </button>

              <button *ngIf="!room.previousPlayerStay" disabled class="book-button btn-book-disable mt-3 ml-2" mat-raised-button>
                {{ rGuestBookMessages?.rooms?.roomIndividualCardBookButton }}
              </button>

              <button *ngIf="room.previousPlayerStay" disabled class="book-button btn-book-disable mt-3 ml-2" mat-raised-button>
                {{ rGuestBookMessages?.rooms?.roomInidvidualCardBookAgainButton }}
              </button>
            </div>
          </div>
          <div *ngIf="!selectedTab.isPackage && !(room?.blockRoom && hideRateDepositAndCancelPoliciesIfSoldOut)" class="deposit-cancel">
            <button
              #depositAndCancellationBtn
              id="depositAndCancellationBtn"
              class="policy-button btn-book-disable"
              mat-raised-button
              (click)="openCanellationDepositPolicy(selectedTab)">
              <i class="fa fa-file-text-o" aria-hidden="true" style="margin-right: 6px"></i
              >{{ rGuestBookMessages?.rooms?.roomDepCanPolicy }}
            </button>
          </div>
        </div>
        <div class="details-all col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <mat-tab-group [selectedIndex]="0" class="mat-tab-group-style">
            <mat-tab
              *ngIf="selectedTab && (selectedTab.expandedDescription || selectedTab.maxOccupancy || selectedTab.size)"
              label="{{ rGuestBookMessages?.rooms?.roomDetailsTabName1 }}">
              <p class="expanded_description custom-expanded_description" [innerHTML]="selectedTab.expandedDescription | safeHtml"></p>
              <div
                class="col-lg-12 col-sm-12 col-xs-12 mr-zero mb-2 additiondetils"
                *ngIf="selectedTab.customFields && selectedTab.customFields.length">
                <a>
                  <span *ngIf="!showMore" (click)="showMore = true" class="additiondetilslabel">
                    {{ rGuestBookMessages?.rooms?.roomAdditionalsDetailsShow }}
                    <i aria-hidden="true" class="fas fa-chevron-circle-down"></i>
                  </span>
                  <span *ngIf="showMore" (click)="showMore = false" class="additiondetilslabel">
                    {{ rGuestBookMessages?.rooms?.roomAdditionalsDetailsHide }} <i aria-hidden="true" class="fas fa-chevron-circle-up"></i>
                  </span>
                </a>
                <br />
                <ng-container *ngIf="showMore">
                  <ng-container *ngFor="let cfield of selectedTab.customFields">
                    <div>
                      <h4 class="font-weight-bold mb-1">{{ cfield.name }}</h4>
                    </div>
                    <div class="indentedText mb-1 pl-2" [innerHTML]="cfield.shortDesc | safeHtml"></div>
                    <div class="indentedText mb-1 pl-2" [innerHTML]="cfield.longDesc | safeHtml"></div>
                  </ng-container>
                </ng-container>
              </div>
              <div class="row mr-zero">
                <div class="col-lg-6 col-sm-6 col-xs-12">
                  <div *ngIf="selectedTab && selectedTab.maxOccupancy" class="mb-2">
                    <p class="font-weight-bold mb-1">{{ rGuestBookMessages?.rooms?.roomMaxOccupancy }}</p>
                    <div class="indentedText mb-1 pl-2 unset-pl">
                      {{ selectedTab.maxOccupancy }} {{ rGuestBookMessages?.rooms?.roomDetailsPeople }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 col-xs-12">
                  <div *ngIf="selectedTab && selectedTab.size">
                    <p class="font-weight-bold mb-1">{{ rGuestBookMessages?.rooms?.roomSize }}</p>
                    <div class="indentedText mb-1 pl-2 unset-pl">
                      {{ selectedTab.size }} <span *ngIf="selectedTab.measurement">{{ selectedTab.measurement }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab *ngIf="selectedTab.isPackage" label="{{ rGuestBookMessages?.rooms?.roomDetailsTabName2 }}">
              <div style="padding: 40px">
                <div>
                  <span style="font-weight: 900; font-size: 16px">{{ rGuestBookMessages?.rooms?.roomPackageIncludesMessage }}</span>
                </div>
                <div style="padding: 20px">
                  <div *ngFor="let description of selectedOffer.offerTextArray">
                    <p *ngIf="description?.length">
                      <i class="fa fa-dot-circle-o" aria-hidden="true"></i> &nbsp;<span [innerHtml]="description | safeHtml"></span>
                    </p>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab
              *ngIf="selectedTab.blockRoom == false && !selectedTab.isPackage"
              label="{{ rGuestBookMessages?.rooms?.roomDetailsTabName3 }}">
              <div *ngIf="details_tab">
                <div class="rate_flows">
                  <div style="margin-top: 10px" class="table-responsive">
                    <table aria-hidden="true" class="rate_table table table-hover">
                      <thead class="rate_table_head">
                        <tr>
                          <ng-container *ngFor="let th of room.thead">
                            <th
                              id="rate_table_header_1"
                              *ngIf="
                                th == 'roomTheadResortFee' &&
                                !rGuestBookRoutePermissions.functionalPermissions?.hideZeroResortFees &&
                                !room.resortFeeTotal
                              ">
                              {{ rGuestBookMessages?.rooms[th] || th }}
                            </th>
                            <th
                              id="rate_table_header_2"
                              *ngIf="th == 'roomTheadResortFee' && room.resortFeeTotal && room.resortFeeTotal != 0">
                              {{ rGuestBookMessages?.rooms[th] || th }}
                            </th>
                            <th
                              id="rate_table_header_3"
                              *ngIf="
                                th == 'roomTheadOtherFee' &&
                                !rGuestBookRoutePermissions.functionalPermissions?.hideZeroOtherFees &&
                                !room.recurringChargesTotal
                              ">
                              {{ rGuestBookMessages?.rooms[th] || th }}
                            </th>
                            <th
                              id="rate_table_header_4"
                              *ngIf="th == 'roomTheadOtherFee' && room.recurringChargesTotal && room.recurringChargesTotal != 0">
                              {{ rGuestBookMessages?.rooms[th] || th }}
                            </th>
                            <th id="rate_table_header_5" *ngIf="th != 'roomTheadResortFee' && th != 'roomTheadOtherFee'">
                              {{ rGuestBookMessages?.rooms[th] || th }}
                            </th>
                          </ng-container>
                        </tr>
                      </thead>
                      <tbody class="rate_table_head">
                        <tr *ngFor="let rates of room.tbody">
                          <td>{{ rates.date | custDate: AppInitializer?.PropertyData?.dateFunctionConfig }}</td>
                          <td align="right" *ngIf="rates.roomRate > 0">
                            <span>{{
                              (rates.roomRate || 0) * newRate
                                | custCurrency
                                  : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                                  : this.countryCode ||
                                      AppInitializer?.PropertyData?.countryCode ||
                                      rGuestBookMessages?.rooms?.roomRateBreakdownText1
                            }}</span>
                          </td>
                          <td align="right" *ngIf="rates.roomRate <= 0">
                            {{ rGuestBookMessages?.rooms?.roomRateBreakdownText2 }}
                          </td>
                          <td
                            *ngIf="!rGuestBookRoutePermissions.functionalPermissions?.hideZeroResortFees && !room.resortFeeTotal"
                            align="right">
                            <span>{{
                              (rates.resortCharges || 0) * newRate
                                | custCurrency
                                  : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                                  : this.countryCode || AppInitializer?.PropertyData?.countryCode || "-"
                            }}</span>
                          </td>
                          <td *ngIf="room.resortFeeTotal && room.resortFeeTotal != 0" align="right">
                            <span>{{
                              (rates.resortCharges || 0) * newRate
                                | custCurrency
                                  : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                                  : this.countryCode || AppInitializer?.PropertyData?.countryCode || "-"
                            }}</span>
                          </td>
                          <td
                            *ngIf="
                              room.thead.includes('roomTheadOtherFee') &&
                              !rGuestBookRoutePermissions.functionalPermissions?.hideZeroOtherFees &&
                              !room.recurringChargesTotal
                            "
                            align="right">
                            <span>{{
                              (rates.otherCharges || 0) * newRate
                                | custCurrency
                                  : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                                  : this.countryCode || AppInitializer?.PropertyData?.countryCode || "-"
                            }}</span>
                          </td>
                          <td *ngIf="room.recurringChargesTotal && room.recurringChargesTotal != 0" align="right">
                            <span>{{
                              (rates.otherCharges || 0) * newRate
                                | custCurrency
                                  : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                                  : this.countryCode || AppInitializer?.PropertyData?.countryCode || "-"
                            }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <div class="row">
                      <h5 class="total_amount col-6 col-sm-6 col-md-6 col-lg-6">
                        <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText3 }}</strong>
                      </h5>
                      <h5 *ngIf="room.days != room.compDays" class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-3">
                        {{
                          (room.roomTotal || 0) * newRate
                            | custCurrency
                              : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                              : this.countryCode || AppInitializer?.PropertyData?.countryCode
                        }}
                      </h5>
                      <h5 *ngIf="room.days == room.compDays" class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-3">
                        {{ rGuestBookMessages?.rooms?.roomRateBreakdownText2 }}
                      </h5>
                      <h5 *ngIf="room.recurringChargesTotal > 0" class="total_amount col-6 col-sm-6 col-md-6 col-lg-6">
                        <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText4 }}</strong>
                      </h5>
                      <h5 *ngIf="room.recurringChargesTotal > 0" class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-3">
                        {{
                          (room.recurringChargesTotal || 0) * newRate
                            | custCurrency
                              : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                              : this.countryCode || AppInitializer?.PropertyData?.countryCode
                        }}
                      </h5>
                    </div>
                    <div *ngIf="!rGuestBookRoutePermissions.functionalPermissions?.hideZeroResortFees && !room.resortFeeTotal" class="row">
                      <h5 class="total_amount col-6 col-sm-6 col-md-6 col-lg-6">
                        <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText5 }}</strong>
                      </h5>
                      <h5 class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-3">
                        {{
                          (room.resortFeeTotal || 0) * newRate
                            | custCurrency
                              : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                              : this.countryCode || AppInitializer?.PropertyData?.countryCode
                        }}
                      </h5>
                    </div>
                    <div *ngIf="room.resortFeeTotal && room.resortFeeTotal != 0" class="row">
                      <h5 class="total_amount col-6 col-sm-6 col-md-6 col-lg-6">
                        <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText5 }}</strong>
                      </h5>
                      <h5 class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-3">
                        {{
                          (room.resortFeeTotal || 0) * newRate
                            | custCurrency
                              : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                              : this.countryCode || AppInitializer?.PropertyData?.countryCode
                        }}
                      </h5>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <h5 class="col-6 col-sm-6 col-md-6 col-lg-6 grand_total grand_title">
                      <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText6 }}</strong>
                      <p>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText7 }}</p>
                    </h5>
                    <h5
                      style="margin-left: 5px"
                      *ngIf="room.quoteTotal > 0"
                      class="col-5 col-sm-5 col-md-5 col-lg-3 grand_total grand_total_value">
                      {{
                        (room.quoteTotal || 0) * newRate
                          | custCurrency
                            : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                            : this.countryCode || AppInitializer?.PropertyData?.countryCode
                      }}
                    </h5>
                    <h5 *ngIf="room.quoteTotal == 0" class="col-5 col-sm-5 col-md-5 col-lg-3 grand_total grand_total_value">
                      {{ rGuestBookMessages?.rooms?.roomRateBreakdownText8 }}
                    </h5>
                  </div>
                  <hr style="margin-top: 0" />
                  <div class="row" style="margin-top: -10px">
                    <h5 class="col-6 col-sm-6 col-md-6 col-lg-6 grand_total grand_title">
                      <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText9 }}</strong>
                    </h5>
                    <h5 style="margin-left: 5px" class="col-5 col-sm-5 col-md-5 col-lg-3 grand_total grand_total_value">
                      {{
                        (room.depositAmountDue || 0) * newRate
                          | custCurrency
                            : this.currencyCode || AppInitializer?.PropertyData?.currencyCode
                            : this.countryCode || AppInitializer?.PropertyData?.countryCode
                      }}
                    </h5>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab
              *ngIf="details_tab && selectedTab.amenities && selectedTab.amenities.length > 0"
              label="{{ rGuestBookMessages?.rooms?.roomDetailsTabName4 }}">
              <div class="outer-tab-layer grid-wrapper">
                <div class="col-md-6 col-lg-6 amenities-outer" *ngFor="let amenities of selectedTab.amenities">
                  <p class="amenities">{{ amenities }}</p>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</mat-drawer-container>
<div *ngIf="!rGuestBookRoutePermissions.functionalPermissions?.togglefilterButtonToTop && !triggerSidebar" class="filter-button">
  <button mat-fab class="button-color" data-dismiss="modal" data-toggle="modal" href="#filter-model">
    <i class="fa fa-filter" aria-hidden="true"></i>
  </button>
</div>
